import moment from "moment";
import { JourFerieDto } from "../dto/GenApi.iNotPaie.Dto/JourFerieDto";
export default class dateHelper {
    public static geLibelleDateMoisAnnee(mois: number, annee: number): string {
        const moisEnLettres = new Date(annee, mois - 1, 1).toLocaleDateString("fr-FR", { month: "long" });

        return `${moisEnLettres.charAt(0).toUpperCase() + moisEnLettres.slice(1)} ${annee}`;
    }

    public static geLibelleDateMois(mois: number): string {
        const moisEnLettres = new Date(1, mois - 1, 1).toLocaleDateString("fr-FR", { month: "long" });

        return `${moisEnLettres.charAt(0).toUpperCase() + moisEnLettres.slice(1)}`;
    }

    /**
     * Formate une date pour l'affichage DD/MM/YYYY
     * @param date
     * @returns string
     */
    public static formatDate(date: Date): string {
        return moment.utc(date).format("DD/MM/YYYY");
    }

    /**
     * Formate une date pour l'url YYYY-MM-DD
     * @param date
     * @returns string
     */
    public static formatDateForUrl(date: Date): string {
        return moment.utc(date).format("YYYY-MM-DD");
    }

    /**
     * Détermine si un jour est le jour actuel
     * Vérifie que c'est le même jour, le même mois et la même année
     * @param date Jour à vérifier
     * @param currentMonth Mois actuel
     * @param currentYear Année actuelle
     * @returns true si c'est aujourd'hui, false sinon
     */
    public static isCurrentDay(date: Date, currentMonth: number, currentYear: number): boolean {
        return moment(date).isSame(moment(), 'day')
            && moment(date).isSame(moment(), 'month')
            && currentMonth === moment().month()
            && currentYear === moment().year();
    }

    /**
     * Détermine si un jour est avant la date actuelle
     * @param date Jour à vérifier
     * @returns true si strictement avant la date du jour, false sinon
     */
    public static isDateBeforeCurrentDay(date: Date) {
        const currentDate = moment.utc().startOf("day");
        const dateDebutMoment = moment.utc(date);

        if (dateDebutMoment.isBefore(currentDate)) {
            return true;
        }

        return false;
    }

    /**
     * Détermine si un jour est un weekend (samedi ou dimanche)
     * @param day Jour à vérifier
     * @returns true si c'est un weekend, false sinon
     */
    public static isWeekend(date: Date): boolean {
        // isoWeekday: 1=Lundi, ..., 6=Samedi, 7=Dimanche
        const dayOfWeek = moment(date).isoWeekday();
        return dayOfWeek === 6 || dayOfWeek === 7;
    }

    /**
     * Vérifie si un jour est un jour férié
     * @param date Jour à vérifier
     * @param storeVariableListeJoursFeries Liste des jours fériés
     * @returns true si c'est un jour non travaillé, false sinon
     */
    public static isNonWorkingDay(date: Date, storeVariableListeJoursFeries: JourFerieDto[]): boolean {
        return storeVariableListeJoursFeries != null &&
            storeVariableListeJoursFeries.find((j) => moment(j.Date).isSame(moment(date), "day")) != null;
    }

    /**
    * Retourne les jours de la semaine en version courte, en commençant par lundi
    * @returns Array des trois premières lettres des jours de la semaine en majuscules
    */
    public static weekdaysShort(): string[] {
        const days = moment.weekdaysShort();
        // On réorganise pour commencer par lundi
        return [...days.slice(1), days[0]];
    }

    /**
     * Formate les heures en décimales pour l'affichage (1.00 -> 1h00, 1.20 -> 1h12, 1.02 -> 1h01, etc.)
     * @param valeur Heures à formater
     * @returns Heures formatées
     */
    public static formatHeuresDecimales(valeur?: string): string {
        if (!valeur) return "";

        const nombre = parseFloat(valeur.replace(",", "."));
        if (isNaN(nombre)) return valeur;

        const heures = Math.floor(nombre);
        const minutes = Math.floor((nombre - heures) * 60);

        if (minutes === 0) return `${heures}h`;

        return `${heures}h${minutes.toString().padStart(2, "0")}`;
    }
}



// WEBPACK FOOTER //
// ./src/Helper/dateHelper.ts